import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "width400px display-inline-block" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "width400px display-inline-block" }
const _hoisted_7 = { class: "width200px display-inline-block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_prop = _resolveComponent("activity-prop")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_processing = _resolveComponent("processing")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ProperAllTextYourOrder,
    footerType: "customize",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, _createSlots({
    default: _withCtx(() => [
      (_ctx.step === 1)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("label", _hoisted_1, _toDisplayString(_ctx.$wordList.ProperAllTextAdditionalSmartPlusaccount), 1),
            _createTextVNode(" $" + _toDisplayString(_ctx.addAppFee) + " ", 1),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _withDirectives(_createVNode("div", null, [
              _createVNode("b", _hoisted_6, _toDisplayString(_ctx.PriceType), 1),
              _createVNode("b", null, "$" + _toDisplayString(_ctx.price), 1)
            ], 512), [
              [_vShow, !_ctx.activity.length]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode("b", _hoisted_7, _toDisplayString(_ctx.PriceType), 1),
              _createVNode(_component_activity_prop, {
                activity: _ctx.activity,
                saveFee: _ctx.savePrice,
                text: '$'+_ctx.price
              }, null, 8, ["activity", "saveFee", "text"])
            ], 512), [
              [_vShow, _ctx.activity.length]
            ]),
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_el_checkbox, {
              class: "margin-right10px",
              modelValue: _ctx.isAgree,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAgree = $event))
            }, null, 8, ["modelValue"]),
            _createVNode("label", {
              class: "cursor-pointer font-size14px",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isAgree = !_ctx.isAgree)),
              innerHTML: _ctx.$wordList.OrderAgree
            }, null, 8, ["innerHTML"])
          ], 64))
        : (_openBlock(), _createBlock(_component_processing, {
            key: 1,
            onSuccess: _ctx.update,
            "pay-jump-url": _ctx.payJumpUrl
          }, null, 8, ["onSuccess", "pay-jump-url"]))
    ]),
    _: 2
  }, [
    (_ctx.step === 1)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
              ]),
              _: 1
            }),
            (_ctx.isAgree)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.createOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.OrderPay), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  disabled: true,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.OrderPay), 1)
                  ]),
                  _: 1
                }))
          ])
        }
      : undefined
  ]), 1032, ["title"]))
}